const env = import.meta.env;

export default {
  api: { baseUrl: env.VITE_API_BASE_URL },
  env: env.MODE,
  full_story: {
    org_id: env.VITE_FS_ORG_ID,
  },
  google: {
    googleClientID: env.VITE_GOOGLE_CLIENT_ID,
    googleTagId: env.VITE_GTAG_ID,
    recaptchaSiteKey: env.VITE_RECAPTCHA_SITE_KEY,
  },
  includeMocks: env.VITE_INCLUDE_MOCKED_FEATURES === "true",
  mode: env.MODE,
  other: {
    accelerateTaxClientId: env.VITE_ACCELERATE_TAX_CLIENT_ID,
    ignisClientId: env.VITE_IGNIS_CLIENT_ID,
    lmnClientId: env.VITE_LMN_CLIENT_ID,
  },
  plaid: { environment: env.VITE_PLAID_ENV },
  posthogApiKey: env.VITE_POSTHOG_API_KEY,
  sentryDashboardDsn: env.VITE_SENTRY_DSN,
  sentryDist: env.VITE_APP_ENV,
  sentryRelease: env.VITE_SENTRY_RELEASE,
  smartyStreetsKey: env.VITE_SMARTY_STREETS_KEY,
  useParserV2: env.VITE_USE_PARSER_V2 === "true",
  widgetUrl: env.VITE_WIDGET_URL,
  ws: {
    broadcaster: env.VITE_WS_BROADCASTER || "pusher",
    cluster: env.VITE_WS_CLUSTER ?? "mt1",
    host: env.VITE_WS_HOST || "realtime-pusher.ably.io",
    key: env.VITE_WS_KEY,
    port: env.VITE_WS_PORT || 443,
  },
};
